






import { Component, Vue, Prop, Inject } from 'vue-property-decorator'

@Component({})
export default class WishSection extends Vue {
  @Prop({ default: () => ({}) }) readonly wish!: any

  wishClick() {
    location.href = this.wish.linkUrl
  }
}
